import { capitalize } from '@mui/material/utils';
export const getDisplayName = (firstName, lastName) => `${capitalize(firstName)} ${capitalize(lastName)}`;
export const trimToUndefined = (input) => {
    if (input === null || input === void 0 ? void 0 : input.trim()) {
        return input.trim();
    }
    return undefined;
};
